import { render, staticRenderFns } from "./FormLogins.vue?vue&type=template&id=4dbc7d4f"
import script from "./FormLogins.vue?vue&type=script&lang=js"
export * from "./FormLogins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports